import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CheckCircle } from "lucide-react";
import { useCompanyLogo } from "@/hooks/use-company-logo";

export default function ClientResetPassword() {
  const logoUrl = useCompanyLogo();
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [password, setPassword] = useState("");
  const [repeat, setRepeat] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (password.length < 10) return setError("Lösenordet måste vara minst 10 tecken");
    if (password !== repeat) return setError("Lösenorden är inte lika");
    setBusy(true);
    try {
      const res = await fetch("/api/client-auth/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const body = await res.json().catch(() => ({}));
      if (!res.ok) setError(body.message || "Något gick fel. Försök igen.");
      else setDone(true);
    } catch {
      setError("Kontrollera din anslutning och försök igen.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <img src={logoUrl} alt="Rätt Order" className="h-16 w-auto max-w-[200px] object-contain" />
          </div>
          <CardTitle className="text-2xl">Välj lösenord</CardTitle>
          <CardDescription>Ange ett nytt lösenord (minst 10 tecken).</CardDescription>
        </CardHeader>
        <CardContent>
          {done ? (
            <div className="space-y-4 text-center" data-testid="section-reset-done">
              <CheckCircle className="h-12 w-12 text-green-500 mx-auto" />
              <p>Lösenordet är sparat.</p>
              <Button className="w-full" onClick={() => window.location.replace("/")} data-testid="button-go-login">Till inloggningen</Button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="new-password">Nytt lösenord</Label>
                <Input id="new-password" type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="input-new-password" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="repeat-password">Upprepa lösenord</Label>
                <Input id="repeat-password" type="password" autoComplete="new-password" value={repeat} onChange={(e) => setRepeat(e.target.value)} data-testid="input-repeat-password" />
              </div>
              {error && <p className="text-sm text-destructive" data-testid="text-reset-error">{error}</p>}
              <Button type="submit" className="w-full" disabled={busy || !token} data-testid="button-save-password">Spara lösenord</Button>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
